import { Location } from 'vue-router';
import { UserRoutes } from 'client/routes/RouteGenerator';
import router from 'client/routes/Router';

const { resetPassword, resetPasswordUserForm } = UserRoutes;

export default {
  goToAdminLogin(location: Location = {}): void {
    router.push({ name: 'Admin Login', ...location });
  },
  goToUserLogin(location: Location = {}): void {
    router.push({ name: 'Login', ...location });
  },
  replaceToUserLogin(location: Location = {}): void {
    router.replace({ name: 'Login', ...location });
  },
  goToUserPasswordResetRequest(location: Location = {}): void {
    router.push({ path: resetPassword, ...location });
  },
  goToUserPasswordResetForm(location: Location = {}): void {
    router.push({ path: resetPasswordUserForm, ...location });
  },
};
